import type { CoprincipalAccountSource } from "../store/schema/AccountSourceList";
import getCoprincipalAccounts, { ContractsSupportedFilter, StartupFilter, } from "./getCoprincipalAccounts";

/**
 * Finds the coprincipal account with the specified primary mailbox GUID.
 * @param mailboxGuid The primary mailbox GUID to look up
 * @returns The matching CoprincipalAccountSource or undefined if not found
 */
export default function getCoprincipalAccountByMailboxGuid(mailboxGuid: string): CoprincipalAccountSource | undefined {
    if (!mailboxGuid) {
        return undefined;
    }
    
    const lowerGuid = mailboxGuid.toLowerCase();
    return getCoprincipalAccounts(StartupFilter.StartingOrCompleteOrError, ContractsSupportedFilter.Any).find(account => account.primaryMailboxGuid?.toLowerCase() === lowerGuid);
}
